export type TNotesCardProps = {
  className?: string;
  width?: string;
  avatarSize?: number;
  createdAt?: string;
  createdOn?: string;
  bookmarkClickHandler?: any;
  data: DataOptions;
};

export type DataOptions = {
  patientName: string;
  patientId: string;
  notes: string;
  id: number;
  notesCreateDate?: string;
  isBookMarked?: boolean;
};

export type TNotesProps = { members?: any; notifications?: any };
export type TNotificationsProps = { searchString:any, filter: any };

export const tabs = [
  {
    name: "All Notifications",
    key: "2",
  },
];

export const membersOption = [
  "Ashley John",
  "Aster Milton",
  "Bob Dylan",
  "Bobaz Darwin",
];
export const colors = ["red", "green", "purple", "orange"];
